<template>
<div class="jigsaw_index">
   <audio src="../../assets/audio/bgmusic.mp3" id="bgmusic" ref="bgmusic" hidden='true' loop  autoplay controls></audio>
   <audio src="../../assets/audio/go.mp3" id="go" ref="go" controls hidden='true' ></audio>
   <div class="jigsawIndex" v-if="gameFlag == 1">
     <div class="jigsawIndex_top">
        <div class="jigsawIndex_top_left">
           <img  src="@/assets/images/jigsaw/back.png" class="jigsawIndex_top_left_back" @click="goBack"/>
           <img  :src="userImg" class="jigsawIndex_top_left_pic"/>
           <span class="jigsawIndex_top_left_name">{{userName}}</span>
        </div>
        <div class="jigsawIndex_top_right">
           <img src="@/assets/images/jigsaw/notice.png" >
        </div>
     </div>
     <div class="jigsawIndex_bottom">
        <div class="jigsawIndex_bottom_box" :class="{'opened':index < active || active == 16,'failed':index == active && !passedFlag}" v-for="index in 16" :key="index" @click="goJigsaw(index)">
           <p>{{index}}</p>
        </div>
     </div>
     <success-dialog :successShow="successShow" :gameType="gameType"></success-dialog>
  </div>
  <jigsaw v-if="gameFlag == 2" @next="next" @restart="restart" @goIndex="goIndex"></jigsaw>
</div>

</template>

<script>
import successDialog from './../../components/jigsaw/success-dialog.vue';
import { _getGameLevel } from '../../api/game';
import {horizontalScreen} from '../../assets/js/horizontal';
import jigsaw from './jigsaw.vue';
export default {
   name:"jigsaw-index",
   components:{
      successDialog,
      jigsaw
   },
   data() {
      return {
         userName:'布丁',// 用户昵称
         gameType:'1',
         userImg:require('@/assets/images/jigsaw/boy.png'),// 用户图片
         active:1,//当前处于第几关
         successShow:false,
         passedFlag:false,
         childId:'',// 儿童id
         gameFlag:1,
      }
   },
   watch:{},
   created() {
      this.childId = localStorage.getItem('childId')
      this.queryGameLevel();
      this.userImg = localStorage.getItem("headImg");
      this.userName = localStorage.getItem("studentName");
      this.gameFlag = localStorage.getItem("gameFlag") ? localStorage.getItem("gameFlag") : 1;
   },
   mounted() {
      horizontalScreen() // 横屏
      this.$refs.bgmusic.pause();
      this.$refs.go.pause();
      if(this.gameFlag == 2){
         this.$refs.bgmusic.play();
         this.$refs.go.play()
      }
      setTimeout(()=>{
         this.successShow = false;
      },5000)
   },
   methods:{
      // 获取游戏关卡
      queryGameLevel() {
         _getGameLevel({gameType:'0',studentId:this.childId}).then(res=>{
            if(res.code == 200){
               if(res.data && JSON.stringify(res.data) != "{}"){
                  let currentLevel = Number(res.data.currentLevel);
                  let successFlag = res.data.isCurrentPassed;
                  this.active = successFlag ? (currentLevel < 16 ? currentLevel + 1 : 16): currentLevel;
                  let level = localStorage.getItem('jigsawLevel');
                  let levelPassedFlag = localStorage.getItem('jigsawSuccessFlag')
                  if(successFlag && currentLevel == 16){
                     if(level == 16 && levelPassedFlag == 'true'){
                        this.successShow = true
                     }

                     this.passedFlag = true
                  }
               }
            }
         })
      },
      // 返回上一页
      goBack() {
         this.gameFlag = 1;
         localStorage.setItem('gameFlag',this.gameFlag)
         this.$router.push('emotion');
         localStorage.setItem('jigsawSuccessFlag',false);
         this.$refs.bgmusic.pause();

      },
      // 进入游戏界面
      goJigsaw(index) {
         if(this.active >= index){
            this.$refs.bgmusic.play();
            this.$refs.go.play()
            localStorage.setItem('jigsawLevel',index)
            this.gameFlag = 2;
            localStorage.setItem('gameFlag',this.gameFlag)
         }
      },
      // 关掉ready go 背景音乐
      closeGo() {
         this.$refs.go.pause()
      },
      // 下一关，重启ready go及背景音乐
      next() {
         this.$refs.bgmusic.play();
         this.$refs.go.play();
      },
      // 游戏重新开始
      restart() {
         this.$refs.bgmusic.play();
         this.$refs.go.play();
      },
      // 游戏返回关卡页面
      goIndex() {
         this.gameFlag = 1;
         localStorage.setItem('gameFlag',this.gameFlag);
         this.$refs.bgmusic.pause();
         this.$refs.go.pause();
         this.queryGameLevel();
      },
   },
}
</script>

<style lang="scss" scoped>
.jigsaw_index{
   width:100%;
   height:100%;
}
.word-go {
      position: absolute;
      width: 100%;
      display: block;
      color: red;
      text-align: center;
      transform: scale(0);
      opacity: 0;
      line-height: 400px;
      z-index: 9999999999;
   }
   .goActive {
      animation: goSlide 1.5s 0s;
   }
   @keyframes goSlide {
      from {
            opacity: 0;
            transform: scale(0);
      }
      to {
            transform: scale(1.7);
            opacity: 1;
      }
   }
.jigsawIndex{
   width:100%;
   height:100%;
   background:url("../../assets/images/jigsaw/index-background.png") no-repeat;
   background-size:cover;
   .jigsawIndex_top{
      display: flex;
      justify-content: space-between;
      .jigsawIndex_top_left{
          margin-left:15px;
         .jigsawIndex_top_left_back{
            width:29px;
            height:29px;
            margin-top:15px;
         }
         .jigsawIndex_top_left_pic{
            width:40px;
            height:40px;
            margin:8px 10px 0 57px;
            border-radius: 50%;
         }
         .jigsawIndex_top_left_name{
            display: inline-block;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color:#fff;
            height:20px;
            line-height:20px;
            margin-top:18px;

         }
      }
      .jigsawIndex_top_right{
         width: 121px;
         height: 58px;
         margin: 8px 16px 0 0;
      }
   }
   .jigsawIndex_bottom{
      width:280px;
      height:280px;
      background: url("../../assets/images/jigsaw/game-level-bg.png") no-repeat;
      background-size:cover;
      margin:-14px auto 0;
      display:flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .jigsawIndex_bottom_box{
         width:64px;
         height:64px;
         border-radius:6px;
         color:#fff;
         text-align: center;
         font-family: PingFangSC-Regular, PingFang SC;
         font-size:20px;
         line-height:64px;
         font-weight:600;
         text-shadow: 0 2px 4px rgba(170,173,26,0.5);
         background: rgba(255,255,255,0.59);
         background-size:100% 100%;
         box-sizing: border-box;
         &:not(:last-child){
            margin-bottom:8px;
         }
         p{
            width:100%;
            height:100%;
         }
         // 游戏通关
         &.opened{
             background: transparent;
         }
         // 通过失败
         &.failed{
            border:2px solid #fff;
            box-shadow: 0 0 4px 0 #fff;

         }
      }
   }
}
</style>
